import React, {Component} from  "react";
import {Row, Col, Divider, Switch } from 'antd';
import {connect} from 'react-redux';

import {View} from "ol";
import {OverviewMap} from 'ol/control.js';

import {addToVisitedList, getColorLayer, getPreviewColorLegend} from './preview_coloring'

import "../../../asset/style/neoviewer/preview.css"

class PreviewMap extends Component {
    constructor(props) {
        super(props);

        this.state = {
            previewColouring: false
        }

        this.previewMap = new OverviewMap({
          className: "preview-map",
          layers: this.props.layers,
          view: new View({
            projection: this.props.view.getProjection(),
            rotation: this.props.view.getRotation(),
            resolutions: this.props.view.getResolutions(),
          }),
          collapsible: false,
          collapsed: false
        });

        this.zoomVisitedMap = {};
        this.zoomVisitedFullMap = {};

        this.props.zoomLevels.map((level) => {
          this.zoomVisitedMap[parseInt(level)] = [];
        });
    
        this.colorLayer = getColorLayer(this.previewMap, this.props.view, this.zoomVisitedMap);
        this.previewMap.getOverviewMap().addLayer(this.colorLayer);
    
        this.props.slidemap.on(
          ['click', 'singleclick', 'moveend'],
          () => {
            if  (this.state.previewColouring) {
                addToVisitedList(this.props.view, this.zoomVisitedFullMap, this.zoomVisitedMap);
                this.colorLayer.getSource().changed();
            }
          }
        )
    }

    componentDidMount() {
        this.previewMap.setTarget('preview-map-to-target');
        console.log('preview mounted');
        this.props.addPreviewMapControl(this.previewMap);
    }

    switchPreviewColoring = (value) => {
        this.setState({
            previewColouring: value
        })
    }

    render(){

        let previewColorLegend = getPreviewColorLegend(this.props.zoomScale, this.props.maxZoom, this.props.urlState.z);

        return(
            <Row className='preview-component overlayed-component app-parent'>
                <Col span={24}>
                    <Row>
                        <Col span={24} id='preview-map-to-target'>
                        </Col>
                    </Row>
                    <Divider/>
                    <Row className='preview-tracking-component'>
                        <Switch 
                            className="preview-tracking-switch"
                            defaultChecked={false} 
                            size="small"
                            checked={this.state.previewColouring}
                            onChange={this.switchPreviewColoring}
                        />
                        <span className="preview-tracking-text unselectable">Show Seen Area</span> 
                    </Row>
                    {this.state.previewColouring ? previewColorLegend : undefined}
                </Col>
            </Row>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        urlState: state.viewerUrlReducer,
    }
}

export default connect(mapStateToProps)(PreviewMap);